import { ProductType } from '@/shared/enums';
import { getSecureUrl } from '@/shared/utils';

export default function defaultImage(product, opts = {}) {
  let type = 'default';
  const images = {
    default: '/static/images/no-image.jpg',
    movie: '/static/images/no-image-movie.png',
    series: '/static/images/no-image-series.png',
    tv: '/static/images/no-image-tv.png',
    channel: '/static/images/no-image-channel.png',
  };

  if (product.type === ProductType.PROGRAMME) {
    type = 'tv';
  }

  if (product.type === ProductType.LIVE) {
    type = 'channel';
  }

  if (product.type === ProductType.EPISODE || product.type === ProductType.SERIAL) {
    type = 'series';
  }

  if (product.type === ProductType.VOD) {
    type = 'movie';
  }

  const url = getSecureUrl(images[type]);
  return opts.onlyUrl ? url : `url("${url}")`;
}
